import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useLocation, Navigate } from 'react-router-dom';
import "./animations.css";
import Home from "./pages/Home";
import Menu from './features/menu/Menu';
import SolutionsPage from './pages/SolutionsPage';
import ProductsPage from './pages/ProductsPage';
import Modal from './layouts/Modal';
import ContactForm from './features/contactForm/ContactForm';
import AboutPage from './pages/About';
import OurWorkPage from './pages/OurWorkPage';
import { AnimatePresence } from 'framer-motion';
import CaseStudyMainRaceworks from "./features/ourWork/CaseStudies/CaseStudyMainRaceworks";
import CaseStudyMainOdysseyMedia from "./features/ourWork/CaseStudies/CaseStudyMainOdysseyMedia";
import CaseStudyMainABRFestival from "./features/ourWork/CaseStudies/CaseStudyMainABRFestival";


function App() {

  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const contactForm = <ContactForm setModalOpen={setModalOpen} />;
  const caseStudyMainRaceworks = <CaseStudyMainRaceworks />;
  const caseStudyMainOdyssey = <CaseStudyMainOdysseyMedia />;
  const caseStudyMainABRFestival = <CaseStudyMainABRFestival />;

  return (
    <div className="outer-wrap">
      <Menu setModalOpen={setModalOpen} />
        <AnimatePresence mode="sync">
          <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} key="home"/>
              <Route path="/our-work" element={<OurWorkPage setModalOpen={setModalOpen} modalOpen={modalOpen} />} key="our-work"/>
              <Route path="/solutions" element={<SolutionsPage setModalOpen={setModalOpen} />} key="solutions"/>
              <Route path="/products" element={<ProductsPage setModalOpen={setModalOpen} />} key="products"/>
              <Route path="*" element={<Navigate to="/" replace />} /> 
              {/* <Route path="/about" element={<AboutPage setModalOpen={setModalOpen} />} key="about"/> */}
          </Routes>
        </AnimatePresence>

      {modalOpen == 'contact-form' && 
        <Modal modalInner={contactForm} setModalOpen={setModalOpen} slug={'contact-form'}/>
      }
      {modalOpen == 'the-raceworks-internationalisation' &&
        <Modal modalInner={caseStudyMainRaceworks} setModalOpen={setModalOpen} slug={'the-raceworks-internationalisation'} />
      }
      {modalOpen == 'odyssey-media-bed' &&
        <Modal modalInner={caseStudyMainOdyssey} setModalOpen={setModalOpen} slug={'odyssey-media-bed'} />
      }
      {modalOpen == 'abr-festival' &&
        <Modal modalInner={caseStudyMainABRFestival} setModalOpen={setModalOpen} slug={'abr-festival'} />
      }
    </div>
  );
}

export default App;
